import { ICatalogue } from "../../apis/useGetCatalogueData/types";
import { createContextReducer } from "../../common/helpers/createContextReducer";
import { initialState } from "./constants";
import { ICatalogueContext } from "./types";

export const catalogueReducer = {
	SET_CATALOGUE_DATA: (state: ICatalogueContext, data: ICatalogue[]) => {
		state.products = data;
	},
	SET_ISLOADING: (state: ICatalogueContext, isLoading: boolean) => {
		state.isLoading = isLoading;
	},
	SET_ERROR: (state: ICatalogueContext, errorMessage: string) => {
		state.errorMessage = errorMessage;
	},
	UPDATE_OOS_ITEMS: (state: ICatalogueContext, oosItemIds: number[]) => {
		state.products = state.products.map((product) => {
			if (oosItemIds.includes(Number.parseInt(product.id))) {
				return {
					...product,
					inventory_count: 0,
				};
			}

			return product;
		});
	},
};

const {
	AppProvider: CatalogueProvider,
	useContextActions: useCatalogueActions,
	useContextPartial: useCatalogueContext,
} = createContextReducer(initialState, catalogueReducer);

export { CatalogueProvider, useCatalogueActions, useCatalogueContext };
